import { Grid, IconButton, styled, Typography } from "@mui/material";
import { BigButton } from "./BigButton";
import { BigButtonPagedination } from "./BigButtonPagedination";
// import { primary45 } from "../utils/colors";

type PagingControlProps = {
  totalPages: number;
  pageNum: number;
  setPageNum: (page: number) => void;
};

export default function PagingControl({ totalPages, pageNum, setPageNum }: PagingControlProps) {
  const styles = {
    container: {
      // marginTop: 8,
      // marginBottom: 8,
    },
    inlineFlex: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      
    },
    pageInfo: {
      padding: 7,
      color: '#ffffff',
      fontSize: 16,
    },
  };



  return (
    <Grid style={styles.container}>
      <Grid style={{ ...styles.inlineFlex, }}>
      <Grid
        container
        // xs="auto"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#323639",
          // padding: 0.2,
          borderRadius: 2,
          mt: 0.5,
          gap: 1,
        }}
      >
        <BigButtonPagedination
          title="<"
          onClick={() => setPageNum(pageNum - 1)}
          disabled={pageNum - 1 === -1}
        />
        <Grid style={styles.pageInfo}>
          {pageNum + 1}/{totalPages}
        </Grid>
        <BigButtonPagedination
          title=">"
          onClick={() => setPageNum(pageNum + 1)}
          disabled={pageNum + 1 > totalPages - 1}
        />
        </Grid>
      </Grid>

    </Grid>
  );
}
